import Icon from '../components/Icon.vue';
Icon.register({
  'box-open': {
    width: 640,
    height: 512,
    paths: [{
      d: 'M425.7 256c4.5 0 9-0.6 13.3-1.9l137-39.1v178c0 14.6-10 27.4-24.2 31l-216.4 54.1c-10.1 2.5-20.8 2.5-31 0l-216.2-54.1c-14.2-3.5-24.2-16.3-24.2-31v-178l137 39.2c4.3 1.3 8.8 1.9 13.3 1.9 16.9 0 32.8-9 41.5-23.5l64.2-106.6 64.3 106.6c8.6 14.4 24.5 23.4 41.4 23.4zM638.3 143.8c4.5 9.2-0.3 20.2-10.2 23.1l-197.9 56.5c-7.1 2-14.7-1-18.5-7.3l-91.7-152.1 250.1-31.9c6.9-0.9 13.6 2.7 16.7 8.9zM53.2 41c3.1-6.2 9.7-9.7 16.6-8.9l250.2 31.9-91.8 152c-3.8 6.3-11.4 9.3-18.5 7.3l-197.9-56.5c-9.8-2.8-14.7-13.8-10.1-23z'
    }]
  }
});